import * as React from 'react'
import { useMemo } from 'react'

import type { CustomFieldProps } from './typings'
import { AdditionalInfoListItem } from '@sales-center/components'
import type { CustomFieldTextValue } from '@sales-center/common'
import { CUSTOM_FIELD_VALUE_CLAMP_LINES } from './constants'

type CustomTextProps = CustomFieldProps & {
  value: CustomFieldTextValue
}

export function CustomText(props: CustomTextProps) {
  const {
    customFields,
    value: { customFieldId, text },
  } = props

  const thisField = useMemo(
    () => customFields.find((x) => x.id === customFieldId),
    [customFieldId, customFields],
  )

  if (!thisField) return null

  const subtitle = text ?? ''

  return (
    <AdditionalInfoListItem
      title={thisField.name}
      subtitle={subtitle}
      clampLines={CUSTOM_FIELD_VALUE_CLAMP_LINES}
    />
  )
}
